var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.moveEmarticonGuide}},[(_vm.data == 'banner_emart_2408')?_c('img',{attrs:{"src":require(`/src/assets/images/${_vm.data}.png`),"alt":"이마트 충전형 모바일 지갑 이마티콘 자동 충전 5%추가 혜택 안내 e마티콘"}}):_c('img',{attrs:{"src":require(`/src/assets/images/${_vm.data}.png`),"alt":"이마트 충전형 모바일 지갑 이마티콘 자동 충전 3%추가 혜택 안내 e마티콘"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }